import "assets/scss/pages/home.scss";

import { Box, Container, Grid, Stack } from "@mui/material";
import { FormPotluck, Page } from "components";
import { useTheme } from "contexts";
import { usePotluck } from "hooks";
import { useNavigate } from "react-router-dom";
import { Routes } from "utils";

type Props = {};

export const ManagePotluck = (props: Props) => {
  const navigate = useNavigate();

  const { theme } = useTheme();

  const { potluck } = usePotluck();

  const handleSubmit = () => navigate(Routes.userdashboard);

  if (!potluck) return <Page.Loader />;

  return (
    <Box py={theme.spacing.xxl}>
      <Stack gap={theme.spacing.xxl}>
        <Container>
          <Grid container>
            <Grid item xs={12}>
              <FormPotluck.Form potluck={potluck} onSubmit={handleSubmit} />
            </Grid>
          </Grid>
        </Container>
      </Stack>
    </Box>
  );
};
